(function ($, Global) {
	var pageDemandeDossier = 2;
    function DossierPage() {
        // Déclaration class objet
    }

	DossierPage.prototype.initEvents = function () {
		this.publishers();
	}

	DossierPage.prototype.publishers = function () {
		$(document).on('click', '.page-dossier .panel-heading', function () {
			var $this = $(this);
			var $parent = $this.parent();
			var heightNav = $('.nav-fixed').outerHeight();

            $parent.on('shown.bs.collapse', function () {
                if ($parent.find('.panel-collapse').hasClass('in')) {
                    $('html, body').clearQueue().stop().animate({ scrollTop: $parent.offset().top - heightNav * 2 }, 'slow');
				}
			});
		});

		$(document).on('click', '.dossier-actions .btn-action', function () {
            if ($('.landing-box').exists()) {
				$('html, body').animate({
                    scrollTop: $('.landing-box').offset().top - 10
				}, 'slow');
			}
		});
	}

	Global.DossierPage = DossierPage;
}(jQuery, window));